<template>
  <div>
    <h1 id="title">OEE</h1>
    <div id="app_oee">
      <span v-for="(item, i) in taktTime">
        <span class="row">
          <div class = "col-md-2" id="equips">
            <p><b>Début:</b><br>
              {{timeDisplay(taktTime[i].start)}}</p>
            <p><b>Fin:</b><br>
              {{timeDisplay(taktTime[i].end)}}</p>
          </div>

          <div class = "col-md-2" id="equips">
            <p><b>Equipement:</b><br>
              {{taktTime[i].code}}</p>
            <p><b>Takt Time:</b><br>
              {{taktTime[i].takt_time}} min</p>
            <p><b>Lead Time:</b><br>
              {{taktTime[i].lead_time}} min</p>
          </div>

          <div class = "col-md-1" id="equips" v-for="(item, n) in taktTime[i].times">
            <h2 v-if="(n == taktTime[i].times.length - 1) && (taktTime[i].finished == false)" class="poste">Poste {{n+1}}</h2>
            <h2 v-else class="poste_done">Poste {{n+1}}</h2>
            <p><b>Temps écoulé:</b><br>
              {{taktTime[i].times[n]}} min</p>
          </div>
        </span>
      </span>
    </div>
  </div>
</template>
<script>

import server from '../../api/server.vue'

export default {
  name: 'Oee',
  props: ['step', 'title'],
  data() {
    return {
      message: null,
      value: 0,
      warningSeen: false,
      lastScan: false,
      taktTime: [{'start': '', 'end': '', 'code': '', 'finished': false, 'times': [0], 'takt_time': 0, 'lead_time': 0}]
    };
  },
  methods: {
    clicked: function() {
      this.value = this.value + 1
    },
    getTaktTime: function() {
      if(this._isDestroyed ){
        return;
      }
      server.getOee().then(response => {
            this.taktTime = response.data.oee
          })
          .catch(function (error) {
            console.log(error)
        });
      this.setProtectedTimeout(this.getTaktTime, 5000)
    },
  },
  mounted: function () {
    this.getTaktTime()
  }
};
</script>

  <style type="text/css">
    #title {
      text-align: center;
      padding-top: 10px;
    }

    #app_oee {
      margin-top: 50px;
    }

    #equips {
      box-sizing: border-box;
      box-shadow: 0 0 2px rgba(0,0,0,0.3);
      margin-bottom: 30px;
    }

    .poste {
       padding-top: 12px;
       background-color: orange;
    }

    .poste_done {
      padding-top: 12px;
      background-color: #67ce67;
    }
  </style>


// WEBPACK FOOTER //
// src/components/oee/oee.vue